import {Header} from "./components/Header";
import React from "react";
import {InitOptions} from "../common/models/common.models";
import {BrowserRouter} from "react-router-dom";
import {createRoot} from "react-dom/client";

interface HeaderInitOptions extends InitOptions {
    header?: any;
}

const setTSDomain = (domain: string) => {
    window.tcp.tsDomain = domain;
};

function init(options: HeaderInitOptions) {
    const header = document.getElementsByClassName('ti-header');
    if (header && header.length) {
        const element = header[0] as HTMLElement;
        const isInitialized = element.getAttribute('isInitialized') === 'true';


        const headerProps = {
            ...element.dataset,
            ...options.header,
            isNewBrand: true,
            fixedNotification: true, // correct work for old modules [https://toluna.atlassian.net/browse/TQD-23419]
            baseUrl: options.baseUrl,
            cookieDomain: options.domain,
            setTSDomain,
        };

        if (!isInitialized) {
            element.setAttribute('isInitialized', 'true');
            const root = createRoot(element!);
            root.render(<BrowserRouter><Header id="ti-header" {...headerProps} /></BrowserRouter>);
        }
    }
}

export default {
    init,
    setTSDomain
}
